import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimeline } from '../util/animations'

class AnimatedComponent {
  constructor ($el, timelineOptions = {}, d) {
    this.$el = $el
    this.d = typeof d === 'undefined' ? $el.width() : d
    if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
      this.timelineIn = new TimelineMax(Object.assign({ paused: true }, timelineOptions))
      this.buildTimelineIn()
      bindInViewTimeline($el, this.timelineIn)
    }
  }
}

export default AnimatedComponent



// WEBPACK FOOTER //
// ./scripts/components/AnimatedComponent.js